import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ThePulseOfProgress() {
  return <section data-section-id="229156" id="cultivating-your-perfect-outdoor-sanctuary" className="bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668432/img/luxury_garden_patio.png">
          {}
          <source src="https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/1080/Big_Buck_Bunny_1080_10s_1MB.mp4" type="video/mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-primary/20" />
        
        {}
        <div className="absolute bottom-0 left-0 w-full h-3/4 bg-gradient-to-t from-background via-background/70 to-transparent" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center mt-auto pb-32 md:pb-40">
        <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tighter text-[clamp(2.5rem,8vw,12rem)] text-primary mb-6">
          <span className="block">Organic Precision.</span>
          <span className="block mt-2 md:mt-4">
            <span style={{
            WebkitTextStroke: "max(2px, 0.2vw) var(--color-ring)",
            color: "transparent"
          }}>
              Natural
            </span>{" "}
            Artistry.
          </span>
        </h1>

        <p className="font-default font-medium text-lg md:text-2xl text-foreground max-w-3xl mb-10">
          Campos V Landscaping blends architectural precision with the raw beauty of nature to create your perfect residential or commercial sanctuary.
        </p>

        <Button asChild size="lg" className="text-base md:text-lg px-8 py-6 rounded-md uppercase font-bold tracking-wider shadow-xl shadow-primary/10 hover:shadow-primary/20 transition-all duration-300 bg-ring text-white hover:bg-ring/90">
          <Link to="/OurCraftPage">
            Explore Our Craft
          </Link>
        </Button>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-primary animate-bounce">
        <span className="text-xs font-mono uppercase tracking-widest opacity-80">Discover</span>
        <ChevronDown className="size-6 opacity-80" />
      </div>
    </section>;
}